"use client";

import * as React from "react";
import { DualRangeSlider } from "./dual-range-slider";

export function DualRangeSliderCustomLabelDemo() {
  return (
    <div className="w-[300px]">
      <DualRangeSlider
        defaultValue={[0, 100]}
        min={0}
        max={100}
        step={1}
        label={(value) => `${value}℃`}
      />
    </div>
  );
}
